export default "__VITE_ASSET__Bte0tycf__"